import { MyAccountState } from "@my-account/models";
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { reducer as myInvitationsReducer } from "@my-account/store/reducers/my-invitation.reducer";
import { reducer as myRoleAssignmentsReducer } from "@my-account/store/reducers/my-role-assignment.reducer";

export const reducers: ActionReducerMap<MyAccountState> = {
  myInvitations: myInvitationsReducer,
  myRoleAssignments: myRoleAssignmentsReducer
};

export const selectMyAccountState = createFeatureSelector<MyAccountState>("my-account");

export * as myInvitationsReducer from "@my-account/store/reducers/my-invitation.reducer";
export * as myRoleAssignmentsReducer from "@my-account/store/reducers/my-role-assignment.reducer";
